import type { Project } from '../types'

export const projects: Project[] = [
  {
    id: 'roof',
    titleKey: 'proj.roof.title',
    categoryKey: 'proj.roof.cat',
    locationKey: 'proj.roof.loc',
    descKey: 'proj.roof.desc',
    phases: [
      {
        label: 'before',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/074f5964-5acd-4319-b1d8-0801df3dbd8d.jpg',
        alt: 'Roofing before in Cypress TX — storm damaged shingles curling and missing before full re-roof',
      },
      {
        label: 'process',
        src: 'https://i.imgur.com/1pfRy6W.jpeg',
        alt: 'Roofing process in Cypress TX — crew installing new underlayment during storm damage re-roof',
      },
      {
        label: 'after',
        src: 'https://i.imgur.com/6uT86f3.jpg',
        alt: 'Roofing after in Cypress TX — completed architectural shingle roof on a Houston area home',
      },
    ],
  },
  {
    id: 'foundation',
    titleKey: 'proj.foundation.title',
    categoryKey: 'proj.foundation.cat',
    locationKey: 'proj.foundation.loc',
    descKey: 'proj.foundation.desc',
    phases: [
      {
        label: 'before',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/48f75d5a-e8fd-4bb8-8ce1-aa60641ff36f.jpg',
        alt: 'Foundation repair before in Northwest Houston TX — cracked slab and stair-step brick crack',
      },
      {
        label: 'process',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/fb0fa174-b7a1-406b-8f17-62bb55e40010.jpg',
        alt: 'Foundation repair process in Houston TX — concrete piers and hydraulic jack during slab leveling',
      },
      {
        label: 'after',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/604036e9-99fc-4de3-b365-9bafdde96c48.jpg',
        alt: 'Foundation repair after in Northwest Houston TX — leveled slab, repointed brick and graded drainage',
      },
    ],
  },
  {
    id: 'siding',
    titleKey: 'proj.siding.title',
    categoryKey: 'proj.siding.cat',
    locationKey: 'proj.siding.loc',
    descKey: 'proj.siding.desc',
    phases: [
      {
        label: 'before',
        src: 'https://i.imgur.com/GmnwCmi.jpeg',
        alt: 'Siding replacement before in Spring TX — faded warped wood siding with peeling paint',
      },
      {
        label: 'process',
        src: 'https://imgur.com/A3i5aDQ.jpeg',
        alt: 'Siding replacement process in Spring TX — weather barrier exposed during fiber cement installation',
      },
      {
        label: 'after',
        src: 'https://imgur.com/kQOmlD0.jpeg',
        alt: 'Siding replacement after in Spring TX — new fiber cement lap siding and fresh exterior trim',
      },
    ],
  },
  {
    id: 'gallery',
    titleKey: 'proj.gallery.title',
    categoryKey: 'proj.gallery.cat',
    locationKey: 'proj.gallery.loc',
    descKey: 'proj.gallery.desc',
    phases: [
      {
        label: 'before',
        src: 'https://imgur.com/Efjm1E4.jpeg',
        alt: 'Remodeling before in Tomball TX — enclosed patio prior to gallery room conversion',
      },
      {
        label: 'process',
        src: 'https://imgur.com/T14bEG3.jpeg',
        alt: 'Remodeling process in Tomball TX — new framing, ceiling and drywall during gallery room build',
      },
      {
        label: 'after',
        src: 'https://imgur.com/icHOeVg.jpeg',
        alt: 'Remodeling after in Tomball TX — finished gallery room with new ceiling and interior finishes',
      },
    ],
  },
  {
    id: 'bath',
    titleKey: 'proj.bath.title',
    categoryKey: 'proj.bath.cat',
    locationKey: 'proj.bath.loc',
    descKey: 'proj.bath.desc',
    phases: [
      {
        label: 'before',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/a1336ae0-daa9-478b-a348-f11cef0e9ac9.jpg',
        alt: 'Bathroom remodeling before in Northwest Houston TX — dated tile, tub and old vanity',
      },
      {
        label: 'process',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/8e925466-cabd-4dc6-971d-f92364f53db0.jpg',
        alt: 'Bathroom remodeling process in Houston TX — shower walls waterproofed with backer board',
      },
      {
        label: 'after',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/01405951-7daf-47fc-85ef-7e72bd985c36.jpg',
        alt: 'Bathroom remodeling after in Northwest Houston TX — walk-in glass shower and floating vanity',
      },
    ],
  },
]
